// styles/Common.js
import styled from 'styled-components';

export const Card = styled.div`
  background: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.radii.medium};
  padding: ${(props) => props.theme.spacing(3)};
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: ${(props) => props.theme.spacing(4)};
`;

export const Heading = styled.h2`
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.fontSizes.large};
  margin-bottom: ${(props) => props.theme.spacing(2)};
`;

export const Paragraph = styled.p`
  color: ${(props) => props.theme.colors.textLight};
  font-size: ${(props) => props.theme.fontSizes.medium};
  line-height: 1.4;
`;

export const Button = styled.button`
  background: ${(props) => props.primary ? props.theme.colors.primary : props.theme.colors.surface};
  color: ${(props) => props.primary ? '#FFF' : props.theme.colors.text};
  border: 1px solid ${(props) => props.primary ? props.theme.colors.primary : props.theme.colors.border};
  border-radius: ${(props) => props.theme.radii.small};
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  cursor: pointer;
  font-size: ${(props) => props.theme.fontSizes.medium};
  transition: background 0.2s;
  &:hover {
    background: ${(props) => props.primary ? props.theme.colors.primaryLight : '#F1F3F5'};
  }
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: ${(props) => props.theme.spacing(2)};
  tr {
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
  }
  th, td {
    text-align: left;
    padding: ${(props) => props.theme.spacing(1)};
    font-size: ${(props) => props.theme.fontSizes.small};
    color: ${(props) => props.theme.colors.text};
  }
  th {
    font-weight: bold;
    background: #FAFBFC;
  }
`;

export const Spacer = styled.div`
  width: ${(props) => props.width || '100%'}; 
  height: ${(props) => props.height || 'auto'};
`;

export const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid ${(props) => props.theme.colors.primary};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content:center;
  align-items: center;
  z-index:1000;
`;

export const ModalContent = styled.div`
  background: ${(props) => props.theme.colors.surface};
  padding: ${(props) => props.theme.spacing(3)};
  border-radius: ${(props) => props.theme.radii.medium};
  max-width: 500px;
  width:100%;
`;
